module.exports = __webpack_public_path__ + "static/img/welcome_pop.f433e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/welcome_pop.png
// module id = Cugc
// module chunks = 0